import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT = {
	// "0":"ButtonSubmit0",
	// "1":"Check Box2",
	// "2":"Check Box1",
	// "3":"t114",
	solicitorsName: 't175',
	dateYear: 'Text1',
	dateMonth: 'Text46',
	dateDay: 'Text45',
	datedAt: 't9999',
	enclosures: 'Text41',
	fireinsuranceAgent: 'CC006',
	fireInsurancePolicyNumber: 't14030',
	fireInsuranceName: 't14000',
	mortgageAmount: 't860',
	registryOffice: 't330',
	mortgageDate: 'tSF#1124',
	taxesPaidTo: 'Text37',
	registrationDate: 't@PG#/305',
	parcelIdentification: 't4100',
	registrationNumber: 't1015',
	electronicRegistration: 'CC001',
	legalDescription: 'Text2',
	propertyAddress: 't300',
	mortgagor: 't3389',
	cibcReferenceNumber: 't3175',
};

export interface CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT {
	cibcReferenceNumber: string;
	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;

	electronicRegistration: string;
	registrationNumber: string;

	mortgageDate: string;
	parcelIdentification: string;

	registryOffice: string;
	registrationDate: string;

	mortgageAmount: string;
	taxesPaidTo: string;

	fireInsuranceName: string;
	fireInsurancePolicyNumber: string;
	fireinsuranceAgent: string;

	enclosures: string;

	datedAt: string;
	dateDay: string;
	dateMonth: string;
	dateYear: string;

	solicitorsName: string;
}
